import Vue from "vue";
import Router from "vue-router";
import store from "@/vuex/store.js";
import Home from "@/views/Home.vue";
import Login from "@/views/unsecured/Login.vue";
import ForgotPassword from "@/views/unsecured/ForgotPassword.vue";
import ResetPassword from "@/views/unsecured/ResetPassword.vue";

Vue.use(Router);
const router = new Router({
  base:
    process.env.VUE_APP_ENV === "oleksii"
      ? "/login-ui/"
      : "/login-ui/v1",
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/forgot-password",
      name: "forgotPassword",
      component: ForgotPassword,
      meta: {
        requiresAuth: false
      },
      beforeEnter: (to, from, next) => {
        if (store.getters.isLoggedIn === true) {
          next({ path: "/" });
        } else {
          next();
        }
      }
    },
    {
      path: "/reset-password",
      name: "resetPassword",
      component: ResetPassword,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      beforeEnter: (to, from, next) => {
        if (store.getters.isLoggedIn === true) {
          next({ path: "/" });
        } else {
          next();
        }
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  const { isLoggedIn } = store.getters;
  if (to.meta.requiresAuth && !isLoggedIn) {
    if (to && to.fullPath && to.fullPath !== "/") {
      // set redirect path if available
      localStorage.setItem("redirect", to.fullPath);
    }
    next({
      path: "/login"
    });
  }
  return next();
});

export default router;
